// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"28":"6f96a404","55":"e5868861","79":"3f9979d9","194":"d38a4d8e","395":"cb55ee74","499":"b489c309","869":"9bcfb7ae"}[chunkId] + ".js";
};